import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const SolanaBet = () => {
  const sectionRef = useRef(null);
  const lineRef = useRef(null);
  const graphRef = useRef(null);

  useEffect(() => {
    // Animation pour la ligne horizontale
    if (lineRef.current) {
      gsap.to(lineRef.current, {
        width: '100%',
        duration: 1.5,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: lineRef.current,
          start: 'top 80%',
          toggleActions: 'play none none none'
        }
      });
    }

    // Animation pour le graphique
    if (graphRef.current) {
      gsap.to('.solana-bet-graph.is-top', {
        opacity: 1,
        duration: 1,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: graphRef.current,
          start: 'top 60%',
          toggleActions: 'play none none none'
        }
      });
    }

    return () => {
      ScrollTrigger.getAll().forEach(trigger => trigger.kill());
    };
  }, []);

  return (
    <section className="section_bet" ref={sectionRef}>
      <div className="padding-global">
        <div className="container-large">
          <div className="sol-price-wrapper">
            <div className="sol-line_wrapper">
              <div className="solana-bet_wrapper">
                <div className="align-center">
                  <div className="max-width-59">
                    <div className="text-align-center">
                      <h2 className="heading-style-h1">Solana is the right blockchain to bet on</h2>
                    </div>
                  </div>
                </div>
              </div>
              <div data-horizontal-line-anim="true" className="horizontal-line" ref={lineRef} style={{ width: '0%' }}></div>
            </div>
            <div className="tag_wrapper">
              <div className="tag">
                <div className="typeface-dm-mono">
                  <div>FEATURES</div>
                </div>
              </div>
            </div>
            <div className="spacer-1"></div>
            <div className="grid is-solana-bet">
              <div className="grid-block">
                <div className="solana-bet_component">
                  <div className="heading-style-h3">
                    <div>5x outperformance vs BTC, 9x vs ETH</div>
                  </div>
                </div>
                <div className="horizontal-line is-dashed"></div>
              </div>
              <div className="grid-block">
                <div className="solana-bet_component">
                  <div className="heading-style-h3">
                    <div>Growing ecosystem</div>
                  </div>
                </div>
                <div className="horizontal-line is-dashed"></div>
              </div>
              <div className="grid-block">
                <div className="solana-bet_component">
                  <div className="heading-style-h3">
                    <div>100x faster than Ethereum</div>
                  </div>
                </div>
                <div className="visible-mobile-landscape">
                  <div className="horizontal-line is-dashed"></div>
                </div>
              </div>
              <div className="grid-block">
                <div className="solana-bet_component">
                  <div className="heading-style-h3">
                    <div>Low fees</div>
                  </div>
                </div>
                <div className="visible-mobile-landscape">
                  <div className="horizontal-line is-dashed"></div>
                </div>
              </div>
            </div>
            <div className="spacer-3"></div>
            <div className="solana-bet-graphwrapper" ref={graphRef}>
              <img
                src={require('../../assets/images/SolanaBet_graphique.svg').default}
                alt="Graphique Solana Bet"
                className="solana-bet-graph"
                loading="lazy"
              />
              <img
                src={require('../../assets/images/SolanaBet_graphique.svg').default}
                alt="Graphique Solana Bet"
                className="solana-bet-graph is-top"
                loading="lazy"
              />
            </div>
            <div className="spacer-3-5"></div>
            <div className="sol-dominance-trigger">
              <div className="max-width-40">
                <div className="heading-style-h3">
                  <p>Solana consistently outperforms ETH and its Layer-2s in daily transactions, sustaining an average of 75% dominance</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SolanaBet;